import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";
import { YardDetailView } from "@/components/yard-detail-view";
import { Route as RootRoute } from "./__root";

export const Route = createFileRoute("/yards/$yardId")({
  component: YardPage,
});

function YardPage() {
  const { user } = RootRoute.useRouteContext();
  const { yardId } = Route.useParams();
  return (
    <DashboardShell userLabel={user?.displayName || user?.loginName || ""}>
      <YardDetailView yardId={yardId} />
    </DashboardShell>
  );
}
